import type { Sticker } from "./types";

export const STICKERS: Sticker[] = [
    {
        name: "BSB-1.png",
        tags: ["супер", "звезда", "суперзвезда", "star", "super", "superstar"],
    },
    {
        name: "BSB-2.png",
        tags: [
            "идея",
            "хорошая идея",
            "отличная идея",
            "гениально",
            "поддерживать",
            "idea",
            "great",
            "great idea",
            "support",
            "in favour",
        ],
    },
    {
        name: "BSB-3.png",
        tags: ["палец вниз", "плохо", "против", "thumbs down", "bad", "against", "dislike"],
    },
    {
        name: "BSB-4.png",
        tags: ["осторожно", "внимание", "alert", "high alert", "attention", "caution"],
    },
    {
        name: "BSB-5.png",
        tags: [
            "да",
            "поддерживать",
            "нравится",
            "за",
            "согласен",
            "соглашаться",
            "поддерживать",
            "подтверждаю",
            "поддерживаю",
            "yeah",
            "support",
            "in favour",
        ],
    },
    {
        name: "BSB-6.png",
        tags: ["вау", "восторг", "нравится", "wow", "great", "like", "excited"],
    },
    {
        name: "BSB-7.png",
        tags: [
            "сон",
            "спать",
            "дремать",
            "скучать",
            "скучно",
            "нудно",
            "snooze",
            "dream",
            "sleep",
            "nap",
            "bored",
        ],
    },
    {
        name: "BSB-8.png",
        tags: ["огонь", "горячо", "горячий", "жара", "жарко", "hot", "fire", "heat", "great"],
    },
    {
        name: "BSB-9.png",
        tags: ["oh my god", "omg", "oh my goodness"],
    },
    {
        name: "BSB-10.png",
        tags: [
            "праздник",
            "вечеринка",
            "праздновать",
            "отмечать",
            "весело",
            "party",
            "party time",
            "celebrate",
            "celebration",
        ],
    },
    {
        name: "BSB-11.png",
        tags: [
            "+1",
            "за",
            "согласен",
            "соглашаться",
            "поддерживать",
            "подтверждаю",
            "поддерживаю",
            "support",
            "in favour",
            "agree",
        ],
    },
    {
        name: "BSB-12.png",
        tags: [
            "да",
            "за",
            "согласен",
            "соглашаться",
            "поддерживать",
            "подтверждаю",
            "поддерживаю",
            "yes",
            "yeah",
            "support",
            "in favour",
            "agree",
        ],
    },
    {
        name: "BSB-13.png",
        tags: [
            "сердце",
            "сердечко",
            "вау",
            "восторг",
            "нравится",
            "поддерживать",
            "heart",
            "wow",
            "excited",
        ],
    },
    {
        name: "BSB-14.png",
        tags: [
            "плохо",
            "не нравится",
            "против",
            "ужасно",
            "hate it",
            "bad",
            "against",
            "dislike",
            "disagree",
        ],
    },
    {
        name: "BSB-15.png",
        tags: [
            "ракета",
            "давай",
            "вверх",
            "поехали",
            "погнали",
            "движение",
            "off",
            "rocket",
            "take off",
            "up",
        ],
    },
    {
        name: "BSB-16.png",
        tags: ["круто", "классно", "крутой", "классный", "fresh", "cool"],
    },
    {
        name: "BSB-17.png",
        tags: [
            "сердце",
            "сердечко",
            "обожать",
            "обожаю",
            "восторг",
            "нравится",
            "поддерживать",
            "heart",
            "love",
            "love it",
            "support",
        ],
    },
    {
        name: "BSB-18.png",
        tags: [
            "ок",
            "окей",
            "хорошо",
            "договорились",
            "согласен",
            "соглашаться",
            "ok",
            "okay",
            "in favour",
            "agree",
            "deal",
        ],
    },
    {
        name: "BSB-19.png",
        tags: [
            "палец вверх",
            "хорошо",
            "круто",
            "классно",
            "поддерживать",
            "thumbs up",
            "agree",
            "support",
            "in favour",
            "great",
        ],
    },
    {
        name: "BSB-20.png",
        tags: ["вопрос", "что", "непонятно", "hmm", "question", "unclear"],
    },
    {
        name: "BSB-21.png",
        tags: ["мир", "все хорошо", "peace"],
    },
    {
        name: "BSB-22.png",
        tags: ["звезда", "сиять", "star", "shine"],
    },
    {
        name: "BSB-23.png",
        tags: ["нет", "против", "no", "nope", "thumbs down", "against", "disagree", "dislike"],
    },
    {
        name: "BSB-24.png",
        tags: ["нет", "против", "категорически", "no", "nope", "against", "disagree", "dislike"],
    },
    {
        name: "BSB-25.png",
        tags: ["почти готово", "песочные часы", "таймер", "almost done", "sandwatch", "timer"],
    },
    {
        name: "BSB-26.png",
        tags: [
            "расслабиться",
            "расслабляться",
            "расслабление",
            "спокойный",
            "chill",
            "relax",
            "calm",
            "relaxed",
        ],
    },
    {
        name: "BSB-27.png",
        tags: ["занят", "работа", "work", "busy", "occupied"],
    },
    {
        name: "BSB-28.png",
        tags: ["фидбек", "обратная связь", "feedback"],
    },
    {
        name: "BSB-29.png",
        tags: [
            "палец вверх",
            "хорошо",
            "круто",
            "классно",
            "поддерживать",
            "thumbs up",
            "agree",
            "support",
            "in favour",
            "great",
        ],
    },
    {
        name: "BSB-30.png",
        tags: ["огонь", "горячо", "горячий", "жара", "жарко", "hot", "fire", "heat", "great"],
    },
    {
        name: "BSB-31.png",
        tags: ["мертвый", "мертвец", "череп", "dead", "skull"],
    },
    {
        name: "BSB-32.png",
        tags: ["так себе", "безразлично", "все равно", "meh"],
    },
];

export const STICKER_NAME_SET = new Set(STICKERS.map((sticker) => sticker.name));
